import React, { useState } from 'react';

const CollapsibleSection = ({ sections }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <div className="collapsible-container">
      {sections.map((section, index) => (
        <div key={index} className={`${activeIndex === index ? 'collapsible-section-active' : 'collapsible-section'} mt-4`}>
          <div style={{ padding: activeIndex === index ? '1rem' : '0' }}>
            <h2 className="collapsible-button" onClick={() => toggleSection(index)}>
              {section.title}
            </h2>
            {activeIndex === index && <div className="collapsible-content">{section.content}</div>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CollapsibleSection;
